class CardExpand {
  constructor(el) {
    this.el = el;
    this.content = el.querySelector(".card-expand");

    this.caret = el.querySelector(".btn-card-expand");
    this.caretIcon = el.querySelector(".btn-card-expand .btn-plus-minus");

    this.animation = null;

    this.isClosing = false;

    this.isExpanding = false;

    this.caret.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();

    /*     this.el.style.overflow = "hidden"; */

    if (this.isClosing || !this.el.open) {
      this.open();
      this.content.classList.add("show");
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
      this.content.classList.remove("show");
    }
  }

  shrink() {
    this.isClosing = true;

    this.caretIcon.classList.remove("open");

    const startHeight = ``;
    const endHeight = ``;

    console.log(startHeight, endHeight);

    if (this.animation) {
      this.animation.cancel();
    }

    this.content.style.maxHeight = "";
    this.content.style.height = "";

    this.animation.onfinish = () => this.onAnimationFinish(false);

    this.animation.cancel = () => (this.isClosing = false);
  }

  open() {
    this.caretIcon.classList.add("open");

    this.content.style.maxHeight = "100%";
    this.content.style.height = "100%";

    this.el.open = true;

    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    /*     const startHeight = `${this.el.offsetHeight}px`;

    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`; */

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.content.animate(
      {
        maxHeight: ["15rem", "100%"],
      },
      {
        duration: 400,
        easing: "ease-in-out",
      },
    );

    /*    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.cancel = () => (this.isExpanding = false); */
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;

    this.isClosing = false;
    this.isExpanding = false;

    /* this.content.style.height = this.el.style.overflow = ""; */
  }
}

document.querySelectorAll(".information-card").forEach((el) => {
  new CardExpand(el);
});
